import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import MOText from 'common/components/atoms/MOText';
import PopupContext from 'common/contexts/PopupContext';
import SplashScreen from 'common/components/atoms/StyledSplashScreen';
import Popup from 'common/components/molecules/Popup';
import { disable } from 'mixpanel-browser';

interface ISplashPopup {
  children?: React.ReactNode,
}

const StyledText = styled(MOText)`
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 28px;
`;

const SplashPopup:React.FC<ISplashPopup> = ({
  children,
}) => {
  const [isPopupVisible, setPopupVisibility] = useState(false);
  const [popupData, setPopupData] = useState<any>({});
  const value = useMemo(() => ({
    isPopupVisible,
    setPopupVisibility,
    popupData,
    setPopupData,
  }), [popupData, setPopupData]);

  return (
    <PopupContext.Provider {...{ value }}>
      <SplashScreen isVisible={isPopupVisible} className="modal">
        <Popup
          {...{
            title: popupData?.title,
            actionText: popupData?.actionText,
            dismissText: popupData?.dismissText,
            actionBtnStyle: popupData?.actionBtnStyle,
            variant: popupData?.variant,
            onAction: popupData?.onAction,
            onDismiss: () => setPopupVisibility(false),
            disabled: popupData.disabled,
          }}
        >
          <StyledText as="p" typographyStyle="body2">{popupData?.message || ''}</StyledText>
        </Popup>
      </SplashScreen>
      {children}
    </PopupContext.Provider>
  )
};

export default SplashPopup;
